import React from "react"


const Seperator = () => {

  return <hr />
}

export default Seperator
